import { render, staticRenderFns } from "./AppointmentBtn.vue?vue&type=template&id=0a405f5e&scoped=true"
import script from "./AppointmentBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentBtn.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppointmentBtn.vue?vue&type=style&index=0&id=0a405f5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a405f5e",
  null
  
)

export default component.exports